import * as ActionTypes from '../../actions/allActions'
import { BookingFlowStep } from '../../actions/acBookingFlow'
import moment from "moment/moment"

const bookingFlowInit = {
	currentStep: BookingFlowStep.WELCOME,
	currentTimeSlotWeek: moment().startOf('isoWeek'),
	showNewResidenceModal: false,
	sodexoTermsAccepted: false,
	acceptCGU: false,
	acceptConvention: false,
	isStepWelcomeValid: false,
	enterZipCodeNotCovered: false,
	emailZipCodeNotCovered: '',
	options: {},
	allowAffiliateChange: true
}
const bookingFlow = (state = bookingFlowInit, action) => {
	switch (action.type) {
		case ActionTypes.BOOKINGFLOW_START:
			return bookingFlowInit
		case ActionTypes.BOOKINGFLOW_METACHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.BOOKING_FLOW_CHECK_ZIP_CODE_SUCCESS:
			if (action.data.covered) {
				return { ...state, ...{ currentStep: BookingFlowStep.NEEDS } }
			}
			return state
		case ActionTypes.BOOKING_FLOW_ENTER_EMAIL_FOR_ZIP_CODE_NOT_COVERED:
			return { ...state, enterZipCodeNotCovered: true }
		case ActionTypes.CREATE_RESIDENCE_SUCCESS:
			return { ...state, showNewResidenceModal: false }
		case ActionTypes.SODEXO_REGISTRATION_SUCCESS:
			return { ...state, currentStep: BookingFlowStep.CONFIRMATION }
		case ActionTypes.LOGOUT:
			return bookingFlowInit
		default:
			return state
	}
}

export default bookingFlow


// WEBPACK FOOTER //
// ./src/reducers/metadata/bookingFlow.js